import { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";

/* Световая нить: тонкая вертикальная линия слева, проходящая через все секции.
   У каждой секции свой отрезок, отрезки стыкуются, поэтому нить выглядит сплошной.
   Заливка растёт по мере прокрутки секции. Только с lg: на узком экране места нет. */
export const Spine = ({ children, className = "" }) => {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 65%", "end 65%"] });
  const fill = useTransform(scrollYProgress, [0, 1], [0, 1]);

  return (
    <div ref={ref} className={`relative mx-auto w-full max-w-6xl ${className}`}>
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-2 hidden w-px lg:block">
        <div className="absolute inset-0 bg-ink-4/70" />
        <motion.div
          style={{ scaleY: reduce ? 1 : fill }}
          className="absolute inset-0 origin-top bg-gradient-to-b from-accent via-accent-soft to-accent-cyan shadow-[0_0_14px_rgba(62,139,255,0.9)]"
        />
      </div>
      {children}
    </div>
  );
};
